<template>
  <div>
    <div id="feedpost-views" class="modal fade">
      <div class="modal-dialog" style="display: flex; justify-content: center">
        <div id="" class="modal-content">
          <div id="" class="col-12" style="background: #000">
            <div class="feedpost-main-contents">
              <i
                class="el-icon-arrow-left"
                style="font-size: 30px; color: white; margin: 0 10px"
                @click="left"
              ></i>
              <img :src="showImg" style="width: 60%" />
              <i
                class="el-icon-arrow-right"
                style="font-size: 30px; color: white; margin: 0 10px"
                @click="right"
              ></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ix: 0,
      imgList: [],
    };
  },
  computed: {
    showImg() {
      return this.imgList[this.ix];
    },
  },
  methods: {
    left() {
      if (this.ix - 1 < 0) {
        this.ix = this.imgList.length - 1;
      } else {
        this.ix = this.ix - 1;
      }
    },
    right() {
      if (this.ix + 1 >= this.imgList.length) {
        this.ix = 0;
      } else {
        this.ix++;
      }
    },
    hideWindow() {
      $("#feedpost-views").modal("hide");
    },
    showWindow() {
      $("#feedpost-views").modal("show");
    },
    setData(imgList, ix) {
      this.ix = ix;
      this.imgList = imgList;
    },
  },
};
</script>

<style scoped>
.feedpost-main-contents {
  background: #000;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (min-width: 1440px) {
  .modal-content {
    min-width: 800px;
  }
}
@media (max-width: 991px) {
  .modal-content {
    min-width: 400px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Social/group/groupImg.vue